module.exports = __webpack_public_path__ + "img/telegram.d2dd3059.svg";